import { StandardizedConnector } from 'src/products/connector/types/connectorTypes';

export const applyTableFilters = (
  data: StandardizedConnector[],
  filters: string[]
) => data.filter((connector) => filters.includes(connector.status));
